import { AttrGroup, AttrSource, AttrValueType, IAttrMeta, RuleAttribute } from '../interfaces';

/** Метаданные атрибутов. Человекочитаемые названия — на фронте, список атрибутов — с бэкенда. */
export const ATTR_META: Record<RuleAttribute, IAttrMeta> = {
  [RuleAttribute.RecipientGeo]: {
    attribute: RuleAttribute.RecipientGeo,
    group: AttrGroup.Recipient,
    valueType: AttrValueType.String,
    source: AttrSource.Geo,
    labelKey: 'attr.recipient.geo',
  },
  [RuleAttribute.RecipientTag]: {
    attribute: RuleAttribute.RecipientTag,
    group: AttrGroup.Recipient,
    valueType: AttrValueType.String,
    source: AttrSource.RecipientTag,
    labelKey: 'attr.recipient.tag',
  },
  [RuleAttribute.RecipientRetailer]: {
    attribute: RuleAttribute.RecipientRetailer,
    group: AttrGroup.Recipient,
    valueType: AttrValueType.String,
    source: AttrSource.Retailer,
    labelKey: 'attr.recipient.retailer',
  },
  [RuleAttribute.ProductTag]: {
    attribute: RuleAttribute.ProductTag,
    group: AttrGroup.Products,
    valueType: AttrValueType.Number,
    source: AttrSource.ProductTag,
    labelKey: 'attr.product.tag',
  },
  [RuleAttribute.ProductBrand]: {
    attribute: RuleAttribute.ProductBrand,
    group: AttrGroup.Products,
    valueType: AttrValueType.Number,
    source: AttrSource.ProductBrand,
    labelKey: 'attr.product.brand',
  },
  [RuleAttribute.AuthorTag]: {
    attribute: RuleAttribute.AuthorTag,
    group: AttrGroup.Author,
    valueType: AttrValueType.String,
    source: AttrSource.AuthorTag,
    labelKey: 'attr.author.tag',
  },
};

/** Порядок групп и атрибутов в конструкторе (по макету). */
export const GROUP_ORDER: { group: AttrGroup; titleKey: string; attributes: RuleAttribute[] }[] = [
  {
    group: AttrGroup.Recipient,
    titleKey: 'group.recipient',
    attributes: [RuleAttribute.RecipientGeo, RuleAttribute.RecipientTag, RuleAttribute.RecipientRetailer],
  },
  {
    group: AttrGroup.Products,
    titleKey: 'group.products',
    attributes: [RuleAttribute.ProductTag, RuleAttribute.ProductBrand],
  },
  {
    group: AttrGroup.Author,
    titleKey: 'group.author',
    attributes: [RuleAttribute.AuthorTag],
  },
];

export const GEO_SEARCH_MIN_LENGTH = 2;
